<template>
  <modal
    ref="addReport"
    :ok-disabled="loading"
    :ok-title="!$parent.id ? 'Pridať' : 'Upraviť'"
    :title="!$parent.id ? 'Pridať hodnoty (kW)' : 'Upraviť hodnoty (kW)'"
    cancel-title="Zrušiť"
    full-height
    name="add-performance"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveReport"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" v-bar>
          <div>
            <b-form-group
              v-if="!$parent.id"
              label="Typ"
              label-cols-sm="5"
              label-for="name"
            >
              <b-form-select v-model="form.name" :select-size="1" name="name">
                <option value="orderedRK">Dohodnutá RK</option>
                <option value="value">Výkony</option>
              </b-form-select>
            </b-form-group>
            <b-form-group
              v-if="!$parent.id"
              label="Obdobie (rok)"
              label-cols-sm="5"
              label-for="year"
            >
              <single-date
                v-model="form.year"
                v-validate="'required'"
                format="YYYY"
                :class="{ 'is-invalid': errors.has('year') }"
                data-vv-as="Obdobie"
                name="year"
              />
              <b-form-invalid-feedback>
                {{ errors.first('year') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="" label-cols-sm="5" label-for="all">
              <b-form-checkbox v-model="all" @input="setAll">
                Rovnaké hodnoty
              </b-form-checkbox>
            </b-form-group>
            <b-form-group
              v-for="(month, k) in $helpers.months()"
              :key="k"
              :label="$helpers.monthNames(k)"
              :label-for="`month-${k}`"
              label-cols-sm="5"
            >
              <vue-autonumeric
                v-model="form[month]"
                :name="`month-${k}`"
                class="form-control"
              />
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import SingleDate from '@/components/inputs/SingleDate'
import Modal from '@/components/Modal'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      all: false,
      form: {},
      field: [],
    }
  },
  watch: {
    'form.january'(val) {
      if (this.all) {
        for (let month of this.$helpers.months()) {
          this.form[month] = val
        }
      }
    },
  },
  methods: {
    fetchData() {
      this.form = {
        name: 'orderedRK',
        energetics_id: parseInt(this.$route.params.energetics_id),
      }
      if (this.$parent.id) {
        this.loading = true
        this.$api
          .get(`reports/${this.$parent.id}/performance/get_form`)
          .then((res) => {
            this.form = res.data.data
            this.loading = false
          })
      }
    },
    setAll(checked) {
      for (let month of this.$helpers.months()) {
        if (checked) {
          this.form[month] = this.form.january
        } else {
          this.form[month] = null
        }
      }
    },
  },
}
</script>
